// STYLES

import "./components/app.scss";

// JS

import "./components/focus/component.js";
import "./components/form-control/component.js";
import "./components/hours/component.js";
import "./components/img/component.js";
import "./components/link/component.js";
import "./components/page/page-loading.js";
import "./components/widgets/modal/component.js";
import "./components/modal/modal-email.js";
import "./components/modal/modal-career.js";
import "./components/page/page-header.mobile.js";
import "./components/page/page-header.mega-menu.js";
import "./components/page/page-header.scroll.js";
import "./components/page/page-header.search.js";
import "./components/search/component";
import "./components/statistic/default.js";
import "./components/widgets/accordion/default.js";
import "./components/widgets/limit-items/default.js";
import "./components/widgets/limit-lines/default.js";
import "./components/widgets/collapse/default.js";
import "./components/widgets/tabs/component.js";
import "./components/widgets/carousel/component.js";
import "./components/widgets/ajax/default.js";
import "./components/svg/component.js";
import "./ext-links.js";

// IMAGES + SVG

function requireAll(r) {
  r.keys().forEach(r);
}
requireAll(require.context("./images/", true, /\.png$/));
requireAll(require.context("./images/", true, /\.svg$/));
requireAll(require.context("./svg-sprite/", true, /\.svg$/));
requireAll(require.context("./site-icons/", true));
